module.exports = __webpack_public_path__ + "static/media/ben.379bff47.webp";